// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2025 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import GetWidgetReservationsRequestModel from '../../model/get-widget-reservations-request-model';
import GetWidgetReservationsRequestDTO from '../dto/get-widget-reservations-request-dto';
import dtoSchema from '../schemas/get-widget-reservations-request-schema';
import ApiPagingRequestModel from '../../model/api-paging-request-model';

export default abstract class GetWidgetReservationsRequestModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<GetWidgetReservationsRequestDTO>) {
    super();
    if (data) {
      this.searchCriteria = data.searchCriteria ?? undefined;
      this.paging = data.paging ? ApiPagingRequestModel.toModel(data.paging) : undefined;
      this.toccoFilter = data.toccoFilter;
    }
  }
  /**
  */
  searchCriteria?: string;
  /**
  */
  paging?: ApiPagingRequestModel;
  /**
  * @minimum 1
  */
  toccoFilter?: string;

  static toModel(dto: DeepPartial<GetWidgetReservationsRequestDTO>): GetWidgetReservationsRequestModel;
  static toModel(dto: DeepPartial<GetWidgetReservationsRequestDTO> | undefined | null): GetWidgetReservationsRequestModel | undefined;
  static toModel(dto: DeepPartial<GetWidgetReservationsRequestDTO> | undefined | null): GetWidgetReservationsRequestModel | undefined {
    return dto ? new GetWidgetReservationsRequestModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<GetWidgetReservationsRequestModel> | GetWidgetReservationsRequestModel): GetWidgetReservationsRequestDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      searchCriteria: unwrapped.searchCriteria,
      paging: unwrapped.paging,
      toccoFilter: unwrapped.toccoFilter,
    } as GetWidgetReservationsRequestDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for GetWidgetReservationsRequestModel, can not map to GetWidgetReservationsRequestDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
